import HomeIcon from '@mui/icons-material/Home';
import { Box, Button, FormControl, Paper, useMediaQuery, useTheme } from '@mui/material';
// import Alert from '@mui/material/Alert'; // removed
import { blue, green } from '@mui/material/colors';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { OrderInfo } from 'adoms-common-lib';
import { QRCodeCanvas } from 'qrcode.react';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { makeStyles } from 'tss-react/mui';
import { CustomerURLInformationUtil } from '../../common/customerURLInformationUtil';
import ApplicationTooBar from '../../components/molecule/ApplicationToolBar';
import BusinessOrderDestinationInfo from '../../components/molecule/BusinessOrderDestination';
import BusinessOrderRequesterInfo from '../../components/molecule/BusinessOrderRequesterInfo';
import OrderGoodsTable from '../../components/molecule/OrderGoodsTable';
import OrderStepBar, { Process } from '../../components/molecule/OrderStepBar';

const useStyles = makeStyles()((theme) => ({
    griditem: {
    },

    table: {
        minWidth: 100,
    },
    paper: {
        padding: '12px',
        textAlign: 'center',
        height: '100%',
    },
    confirmNum: {
        textAlign: 'center',
        height: '100%',
        width: '300px'
    },
    title: {
        flexGrow: 1,
        textAlign: 'center',
        backgroundColor: blue[500],
        color: 'white',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 32,
    },
    link: {
        textDecoration: 'none',
    },
    successOuter: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
    },
    successPaper: {
        backgroundColor: green[50],
        border: `1px solid ${theme.palette.success.light}`,
        padding: theme.spacing(3),
        textAlign: 'center',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
    successIcon: {
        fontSize: 48,
        color: theme.palette.success.main,
    },
}));




function createData(name: string, gram: number, count: number) {
    return { name, gram, count };
}


export default function BusinessOrderComplete() {
    const { classes } = useStyles();
    const theme = useTheme();
    const isUpperMd = useMediaQuery(theme.breakpoints.up('md'));
    const navigate = useNavigate();
    const location = useLocation();
    const order = location.state.order as OrderInfo;
    // URLIDコピーのためシャローコピー（レンダーごとに取り直すと、他処理で削除された場合にtenantId等がundefinedになり得るため、初回だけスナップショット化する）
    const customerURLInformation = { ...CustomerURLInformationUtil.instance.getCustomerURLInformation() };

    const orderViewPath = customerURLInformation?.tenantId
        ? `/requesterview?tenantid=${customerURLInformation.tenantId}&orderid=${order.orderID}`
        : '';

    useEffect(() => {
        if (customerURLInformation !== undefined) {
            CustomerURLInformationUtil.instance.deleteCustomerURLInformation();
        }
    });

    const handleNavigateTopPage = async () => {
        if (customerURLInformation?.urlId != null) {
            await CustomerURLInformationUtil.instance.updateCustomerURLInformationByUrlId(customerURLInformation.urlId);
            navigate(`/${customerURLInformation.urlId}`);
        } else {
            console.log("undefined urlId");
        }
    }

    const handleNavigateOrderViewPage = () => {
        if (!customerURLInformation?.tenantId) {
            navigate('/forbidden403Page');
            return;
        }
        navigate(orderViewPath);
    };

    return (
        <div>
            <Grid container justifyContent="center" xs={12} spacing={1}>
                <Grid item xs={12} sm={12} >
                    <ApplicationTooBar label="配送依頼完了" />
                </Grid>
                <Grid item xs={12} sm={12} className={classes.griditem}>
                    <OrderStepBar process={Process.Complete} />
                    <Grid item xs={12}>
                        {/* Replaced Alert with centered Paper */}
                        <Box className={classes.successOuter}>
                            <Paper elevation={0} className={classes.successPaper}>
                                <Grid container justifyContent="center">
                                    <Grid container xs={12} alignContent={"center"} spacing={2}>
                                        <Grid item xs={12}>
                                            <Typography sx={{ whiteSpace: 'pre-line' }}>
                                                {!isUpperMd ? (`以下の内容で配送依頼が完了しました。
                                                配送可能な場合10分程度で
                                                ドローンの出発・到着時間を
                                                ご指定の連絡先へご連絡いたします。
                                                お荷物は出発時刻の30分前に
                                                ポートにお持ち込みいただき
                                                ドローンオペレーターに
                                                お渡しください。`) : (`以下の内容で配送依頼が完了しました。
                                                配送可能な場合、10分程度でドローンの出発・到着時間をご指定の連絡先へご連絡いたします。
                                                お荷物は、出発時刻の30分前にポートにお持ち込みいただき、
                                                ドローンオペレーターにお渡しください。`)}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Button variant='contained' onClick={handleNavigateOrderViewPage} sx={{ maxWidth: 300 }}>
                                                配送状況確認ページ
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Box display="flex" justifyContent="center">
                                                {orderViewPath !== '' ? (
                                                    <QRCodeCanvas value={`${window.location.origin}${orderViewPath}`} />
                                                ) : null}
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Box>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12} className={classes.griditem}>
                    <div>
                        <Typography className={classes.title} variant="h6" component="div">
                            確認番号
                        </Typography>
                        <Paper className={classes.paper} elevation={0}>
                            <Grid container justifyContent="center">
                                <Grid item xs={12} sm={12} className={classes.griditem}>
                                    <Typography variant="h5" component="div" color="secondary">
                                        {order.orderID}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} sm={2} className={classes.griditem}>
                                </Grid>
                                <Grid item xs={2} sm={2} className={classes.griditem}>
                                </Grid>

                            </Grid>

                        </Paper>
                    </div>
                </Grid>
                {/* <Typography className={classes.title} variant="h6" component="div">
                外部注文情報
                </Typography>
                <Grid item xs={12} sm={12} className={classes.griditem}>
                    <Paper className={classes.paper} elevation={0}>
                        外部注文番号
                        <Typography variant="h5" component="div" color="secondary">
                            {order.externalOrderID !== undefined ? order.externalOrderID : "連携なし"}
                        </Typography>
                    </Paper>
                </Grid> */}
                <Typography className={classes.title} variant="h6" component="div">
                    フライト予定時間
                </Typography>
                <Grid item xs={12} sm={12} className={classes.griditem}>
                    <Paper className={classes.paper} elevation={0}>
                        <Typography variant="h5" component="div" color="secondary">
                            {
                                order.preferredDeliveryDate !== '' &&
                                    order.preferredDeliveryTime !== '' ?
                                    `${order.preferredDeliveryDate} ${order.preferredDeliveryTime}` :
                                    "指定なし"
                            }
                        </Typography>
                    </Paper>
                </Grid>
                <Typography className={classes.title} variant="h6" component="div">
                    荷送人様の情報
                </Typography>
                <Grid item xs={12} sm={12} className={classes.griditem}>
                    <BusinessOrderRequesterInfo order={order} />
                </Grid>

                <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
                    荷受人様の情報
                </Typography>
                <Grid item xs={12} sm={12} className={classes.griditem}>
                    <BusinessOrderDestinationInfo order={order} />
                </Grid>

                <Typography className={classes.title} variant="h6" component="div">
                    発着ポート
                </Typography>
                <Grid item xs={12} sm={12} className={classes.griditem}>
                    <Paper className={classes.paper} elevation={0}>
                        {order.departure.name} ⇒ {order.arrival.name}
                    </Paper>
                </Grid>

                <Typography className={classes.title} variant="h6" component="div">
                    配送物
                </Typography>
                <Grid item xs={12} sm={12} className={classes.griditem}>
                    <OrderGoodsTable order={order} />
                </Grid>

                <Grid item xs={12} sm={12} className={classes.griditem}>
                    <Paper className={classes.paper} elevation={0}>
                        <FormControl variant="standard" className={classes.formControl}>
                            <IconButton
                                edge="start"
                                color="primary"
                                aria-label="menu"
                                size="large"
                                onClick={() => handleNavigateTopPage()}
                            >
                                <HomeIcon /><Typography>ホームに戻る</Typography>
                            </IconButton>
                        </FormControl>
                    </Paper>
                </Grid>
            </Grid>
        </div >
    );
}